import { useState, useEffect } from 'react';

import { applyPromo, removePromo } from '../../actions/cart';
import Checkbox from '../form/Checkbox';
import Alert from 'react-s-alert';

const PromoEntry = ({ userId, cartId, promos = [], onPromoUpdate = () => {} }) => {
    const [value, setValue] = useState(promos?.[0] || '');

    useEffect(() => {
        if (promos?.length) {
            setValue(promos[0]);
        } else {
            setValue('');
        }
    }, [promos]);

    const handleApplyPromo = async (e) => {
        e.preventDefault();
        try {
            let { data } = await applyPromo(userId, cartId, value);
            onPromoUpdate(data);
        } catch {
            Alert.error(`Error applying promo ${value}.`);
        }
    };

    const handleRemovePromo = async (e) => {
        e.preventDefault();
        try {
            let { data } = await removePromo(userId, cartId);
            onPromoUpdate(data);
        } catch {
            Alert.error(`Error removing promo`);
        }
    };

    const handleSampleChange = async (isChecked) => {
        if (isChecked) {
            try {
                let { data } = await applyPromo(userId, cartId, 'SALESSAMPLE');
                onPromoUpdate(data);
                return;
            } catch {
                Alert.error(`Error applying promo.`);
                return;
            }
        }
        let { data } = await removePromo(userId, cartId);
        onPromoUpdate(data);
    };
    return (
        <div className="form-flex">
            <Checkbox
                id="sales_sample_promo"
                className="mb-4"
                checked={!!(promos || []).includes('SALESSAMPLE')}
                onChange={handleSampleChange}
                label="Sales Sample Promo"
            />
            <label htmlFor="coupon_code">Promotion Code</label>
            <div className="input-box">
                {!!promos?.length && (
                    <>
                        <span style={{ flex: 1 }}>{promos[0]}</span>
                        <button className="button" type="button" onClick={handleRemovePromo}>
                            Remove
                        </button>
                    </>
                )}
                {!promos?.length && (
                    <>
                        <input
                            type="text"
                            id="coupon_code"
                            name="coupon_code"
                            placeholder="Add a promotion code"
                            value={value}
                            onChange={(e) => setValue(e.target.value)}
                        />
                        <button className="button" type="button" onClick={handleApplyPromo}>
                            Apply
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};
export default PromoEntry;
